export enum OptionsReasonEnum {
	PRAISE = 'Elogios',
	INFORMATION = 'Informações',
	SUGGESTION = 'Sugestões',
	COMPLAINTS = 'Reclamações',
}
